import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { ColorTypes } from "@omegagrid/core";
import { msg } from "@omegagrid/localize";
import rp, { AppComponent, BaseSidebar, Browser, BrowserEvent, BrowserState } from "@reporting/rp-app-host";
import { style } from "./sidebar.style";
import { DeploymentBrowserAdapter } from "../adapters";
import { GlobalRights } from "@reporting/rp-types/core";

@customElement('rp-mf-deployment-sidebar')
export class Sidebar extends AppComponent {

	static styles = [...BaseSidebar.styles, style];

	@query('rp-browser')
	browser: Browser;

	private _browserAdapter: DeploymentBrowserAdapter;
    get browserAdapter() {
        if (!this._browserAdapter) {
            this._browserAdapter = new DeploymentBrowserAdapter();
			this._browserAdapter.isReadonly = this.isReadonly;
        }
        return this._browserAdapter;
    }

	private isReadonly = false;

	async connectedCallback() {
		super.connectedCallback();
		this.isReadonly = rp.userProvider.hasRight(GlobalRights.DeploymentRead) && !rp.userProvider.hasRight(GlobalRights.Deployment);
	}

	firstUpdated() {
		this.browser.addEventListener('browser.state', this._onChangeState);
		this.browser.state = this.state?.deploymentBrowser as BrowserState;
	}

	getState() {
		return {
			name: 'sidebar',
			deploymentBrowser: this.browser?.getState(),
		}
	}

	refresh = () => {
		this.browser.refresh();
	}

	toggleCollapse = () => {
		this.browser.tree.toggleTreeCollapse();
	};

	_onChangeState = () => {
		this.dispatchStateEvent();
	}

	_onSelect = (e: BrowserEvent) => {
		rp.host.open(e.node.key, {title: e.node.value});
	}

	render = () => html`
		<div class="controls">
			<div class="controls-title">${rp.accountingProvider.accounting.db_server_name}</div>

			${this.isReadonly ? null : html`
				<og-button
					icon="plus"
					color="transparent"
					@click="${(e: PointerEvent) => {
						e.stopImmediatePropagation();
						this.host.openModalSidebar({id: 'deployment-threadForm', caption: msg('New object')});
					}}">
				</og-button>
			`}

			<og-button
				icon="arrows-rotate"
				color="transparent"
				@click="${(e: PointerEvent) => {
					e.stopImmediatePropagation();
					this.refresh();
				}}">
			</og-button>

			<og-button
				icon="square-plus"
				color="transparent"
				@click="${(e: PointerEvent) => {
					e.stopImmediatePropagation();
					this.toggleCollapse();
				}}">
			</og-button>
		</div>

		<div class="body">
			<rp-browser id="browser" .adapter="${this.browserAdapter}" @browser.select="${this._onSelect}"></rp-browser>
		</div>
	`;

}
